import {Link} from 'react-router-dom';
import {Trans} from '../../i18n/trans';
import {Footer} from '../../ui/footer/footer';
import {StaticPageTitle} from '../../seo/static-page-title';
import {
  PricingTable,
  type AudienceSegment,
} from '@common/billing/pricing-table/pricing-table';
import {SiteHeader} from '../../ui/navigation/site-header';
import {useState} from 'react';

export function PricingPage() {
  const [audience, setAudience] = useState<AudienceSegment>('individual');
  const showIndividualPlans = audience === 'individual';

  return (
    <div className="min-h-screen bg-[#f5f5f7] text-main dark:bg-[#14161a] dark:text-[#f3f4f6]">
      <StaticPageTitle>
        <Trans message="Pricing" />
      </StaticPageTitle>
      <SiteHeader active="plans" />
      <div className="relative mx-auto w-full max-w-[1895px] px-[6px] pb-[24px] lg:pb-[25px]">
        <div className="mx-auto w-full max-w-[1565px] overflow-x-hidden pt-32 md:pt-44">
          <PricingTable
            className={showIndividualPlans ? 'mb-40 md:mb-56' : undefined}
            audience={audience}
            onAudienceChange={setAudience}
          />
          {showIndividualPlans ? <ContactSection /> : null}
        </div>
        <Footer className="mt-[44px] lg:mt-[120px] lg:min-h-[190px]" />
      </div>
    </div>
  );
}

function ContactSection() {
  return (
    <div className="my-20 p-24 text-center md:my-80">
      <p className="mx-auto max-w-[640px] text-[16px] font-medium leading-normal text-[#535353] dark:text-[#b3bcc8] md:text-[18px]">
        Do you have any questions or suggestions? We&apos;ll assist you.
      </p>
      <div className="mt-24 flex justify-center md:mt-28">
        <Link
          to="/contact"
          className="inline-flex h-[60px] w-[141px] items-center justify-center rounded-[24px] border-2 border-divider bg-[#2B7E20] text-[17px] font-medium leading-normal text-white transition-opacity hover:opacity-90"
        >
          Contact us
        </Link>
      </div>
    </div>
  );
}
